var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"action",attrs:{"aria-label":_vm.$t('prompts.newDir'),"title":_vm.$t('prompts.newDir'),"id":"new-file-button"},on:{"click":_vm.newFolder}},[_c('folder-plus-icon',{staticClass:"custom-class",attrs:{"size":"1.5x"}}),_c('span',[_vm._v(_vm._s(_vm.$t('prompts.newDir')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }